import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { enrichmentPlugin } from './enrichment-plugin';
import { getCurrentIdentity } from './current-identity';
export default class AmplitudeClientHandler {
    static #instance;
    #isInitialized = false;
    constructor() { }
    static get instance() {
        if (!this.#instance)
            this.#instance = new AmplitudeClientHandler();
        return this.#instance;
    }
    // Calls made before init() are queued by the SDK and sent once it runs.
    init(apiKey, options = {}) {
        if (this.#isInitialized)
            return;
        this.#isInitialized = true;
        const { getEventProperties, skipEngagement, ...browserOptions } = options;
        // Must be added before init(), or Guides & Surveys can boot without the user.
        if (!skipEngagement)
            amplitude.add(engagementPlugin());
        if (getEventProperties)
            amplitude.add(enrichmentPlugin(getEventProperties));
        // Per-subdomain storage; the default cookie shares one identity across portals.
        amplitude.init(apiKey, {
            autocapture: true,
            identityStorage: 'localStorage',
            ...browserOptions,
        });
    }
    // The SDK reads the user and device ids when it processes the event, after a
    // reset() that may follow (e.g. a logout event), so they're stamped at call time.
    track(eventType, properties) {
        amplitude.track(eventType, properties, getCurrentIdentity());
    }
    identify(userId, userProperties) {
        amplitude.setUserId(userId);
        if (userProperties)
            this.setUserProperties(userProperties);
    }
    setUserProperties(userProperties) {
        const identify = new amplitude.Identify();
        Object.entries(userProperties).forEach(([key, value]) => {
            if (value === undefined)
                return;
            identify.set(key, value);
        });
        amplitude.identify(identify);
    }
    reset() {
        amplitude.reset();
    }
}
//# sourceMappingURL=client-handler.js.map